'use strict';

var $ = require('jquery');
import { throttle } from 'lodash';

/** Changes DOM when in edit mode for certain use cases where editing doesn't work otherwise
 * @module DomChanger
 * @requires jquery
 * @requires lodash
 */
function DomChanger() {

	this.disableOrbit = function(element) {
		$(element).find('.orbit-container')
			.each(function() {
				$(this)
					.find('.orbit-bullets-container')
					.remove()
					.end()
					.find('[data-orbit]')
					.off()
					.find('*')
					.off()
					.end()
					.find('li')
					.css({
						display: 'block',
						position: 'static',
						margin: 0
					});
			});
	};

	this.setup = function(element) {
		this.observer = new MutationObserver(throttle(this.disableOrbit.bind(this, element), 1000));
		this.observer.observe(element, { childList: true, attributes: true, subtree: true, characterData: true });
	};

}

module.exports = DomChanger;
